import {Component, Vue} from "vue-property-decorator";
import {WebSocketSource} from "@/utils/WebSocketSource";

/**
 * グローバルパラメータ型
 */
export interface GlobalParamsType {
  /** 通知メッセージ */
  notification: string;

  /** メンテナンス中メッセージ */
  maintenance: string;

  /** サービス状態 */
  status: 'open' | 'closed';
}

/**
 * クライアントパラメータ型
 */
export interface ClientParamsType {
  /** クライアントリビジョン */
  revision: string;
}

/**
 * 基本メッセージ型
 */
interface BaseMessageType {
  /** メッセージ種別 */
  type: string;

  /** 本文 */
  data: any;
}

/**
 * HCM イベント購読クラス
 */
@Component
export default class HcmSubscriber extends Vue {
  /** 再接続インターバル (ミリ秒) */
  private static RECONNECT_INTERVAL_MILLIS = 5000;

  /** ピンインターバル (ミリ秒) */
  private static PING_INTERVAL_MILLIS = 30000;

  /** WebSocketSource */
  private wss: WebSocketSource;

  /** ping タイマーID */
  private pingTimerId: number | undefined = undefined;

  /**
   * コンストラクタ
   */
  constructor() {
    super();
    this.wss = new WebSocketSource(HcmSubscriber.createWsUrl(), ws => {
      ws.addEventListener('open', e => {
        this.handleOpen();
      });
      ws.addEventListener('close', _ => {
        this.handleClose();
      });
      ws.addEventListener('message', e => {
        this.receiveMessage(JSON.parse(e.data));
      });
    });
  }

  created() {
    this.wss.connect();
  }

  destroyed() {
    this.wss.getIfOpen().then(ws => {
      ws.close();
    }, _ => {
      // OK
    });
  }

  /**
   * WebSocket がオープンした後に呼び出されます
   */
  handleOpen() {
    this.pingTimerId = window.setInterval(() => {
      this.wss.getIfOpen().then(ws => {
        ws.send(JSON.stringify([{type: 'ping'}]));
      });
    }, HcmSubscriber.PING_INTERVAL_MILLIS);
  }

  /**
   * WebSocket がクローズした後に呼び出されます
   */
  handleClose() {
    window.clearInterval(this.pingTimerId);
    window.setTimeout(() => {
      this.wss.connect();
    }, HcmSubscriber.RECONNECT_INTERVAL_MILLIS);
  }

  /**
   * WebSocket からメッセージが送られて来た後に呼び出されます
   *
   * @param messages メッセージ
   */
  receiveMessage(messages: BaseMessageType[]) {
    for(const message of messages) {
      if(message.type === 'pong') {
        continue;
      }

      this.$store.commit({
        type: message.type,
        payload: message.data
      });
    }
  }

  /**
   *
   */
  render() {
    return; // nothing to render
  }

  /**
   * WebSocket の URL を生成します
   *
   * @returns WebSocket の URL
   */
  private static createWsUrl(): string {
    const l = window.location,
        wsProtocol = l.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${wsProtocol}//${l.host}${process.env.BASE_URL}hcm/api/v1/subscribe`;
  }
}
